import { render } from "./NotificationsManager.vue?vue&type=template&id=7e3553af&scoped=true"
import script from "./NotificationsManager.vue?vue&type=script&lang=js"
export * from "./NotificationsManager.vue?vue&type=script&lang=js"

import "./NotificationsManager.vue?vue&type=style&index=0&id=7e3553af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3553af"]])

export default __exports__